import CricketStats from "./CricketStats";
export default CricketStats;
